module.exports = __webpack_public_path__ + "static/media/pixels.ba59c7f6.png";